import { render, staticRenderFns } from "./edit-device-archive.vue?vue&type=template&id=0d870ac8&scoped=true"
import script from "./edit-device-archive.vue?vue&type=script&lang=js"
export * from "./edit-device-archive.vue?vue&type=script&lang=js"
import style0 from "./edit-device-archive.vue?vue&type=style&index=0&id=0d870ac8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d870ac8",
  null
  
)

export default component.exports